import React, { useContext, useEffect } from "react";
import { Routes, Route, Navigate, Switch } from "react-router-dom";
import { AuthContext } from "context/auth.context";
import routes from "routes";
import { un_auth_routes } from "routes";
import { manager_routes } from "routes";

export default function MainRoutes() {
  const { authenticated, userDoc } = useContext(AuthContext);
  console.log(authenticated);
  useEffect(() => { }, []);
  if (!authenticated) {
    return (
      <Routes>
        {un_auth_routes.map((route) => {
          return <Route exact path={route.route} element={route.component} key={route.key} />;
        })}
        <Route path="*" element={<Navigate to="/authentication/sign-in" />} />;
      </Routes>
    )
  }
  else if (userDoc.role?.name === "Super Admin") {
    return (
      <Routes>
        {routes.map((route) => {
          return <Route exact path={route.route} element={route.component} key={route.key} />;
        })}
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>
    );
  }
  else if (userDoc.role?.name === "Branch Admin") {
    return (
      <Routes>
        {manager_routes.map((route) => {
          return <Route exact path={route.route} element={route.component} key={route.key} />;
        })}
        <Route path="*" element={<Navigate to="/packages" />} />
      </Routes>
    );
  }
  // return (
  //   <Routes>
  //     {routes.map((route) => {
  //       if (route.route && route.key == "sign-in" && !authenticated) {
  //         return <Route exact path={route.route} element={route.component} key={route.key} />;
  //       } else if (authenticated) {
  //         return <Route exact path={route.route} element={route.component} key={route.key} />;
  //       }
  //       if (!authenticated) {
  //         return <Route path="*" element={<Navigate to="/authentication/sign-in" />} />;
  //       } else {
  //         return <Route path="*" element={<Navigate to="/dashboard" />} />;
  //       }
  //       return null;
  //     })}
  //   </Routes>
  // );
}
